export default class Map {
	constructor() {
		this.marker = document.querySelector('[data-marker]');
		this.markerHtml = this.marker.innerHTML;
		this.markerCoords = { lat: parseFloat(this.marker.dataset.lat), lng: parseFloat(this.marker.dataset.lng) };
		this.map = document.querySelector('[data-map]');
		this.initMap();
	}

	initMap() {
		const map = new google.maps.Map(this.map, {
			zoom: parseInt(this.map.dataset.zoom) || 17,
			center: this.markerCoords,
		});

		this.addMarker(map);
	}

	addMarker(map) {
		const marker = new google.maps.Marker({
			position: this.markerCoords,
			map,
		});

		this.addInfoBox(map, marker);
	}

	addInfoBox(map, marker) {
		const infowindow = new google.maps.InfoWindow({
			content: this.markerHtml,
		});

		infowindow.open({
			anchor: marker,
			map,
			shouldFocus: false,
		});
	}
}
